import type { MedicationRepeat } from '@quromedical/models';

import { type EnumMedicationRepeat, RepeatDescription } from './types';

export const mapMedicationRepeatToRepeatName = (
  repeat?: Partial<MedicationRepeat>,
): EnumMedicationRepeat | undefined => {
  if (!repeat) {
    return undefined;
  }
  const descriptions = Object.keys(RepeatDescription) as EnumMedicationRepeat[];

  const foundDescription = descriptions.find((key) => {
    const value = RepeatDescription[key];
    const isSame =
      value.frequency === repeat.frequency &&
      value.period === repeat.period &&
      value.periodUnit === repeat.periodUnit;

    return isSame;
  });

  return foundDescription;
};
